// Service categories as configured in Jane (Jane Thrive) for
// Bayside Birth & Pelvic Health. Individual treatments and prices live in Jane
// only - the website lists the general areas of care and sends people to Jane to book.

export const JANE_BASE_URL = 'https://baysidebirthandpelvichealth.janeapp.com';

export const JANE_BOOKING_URL = `${JANE_BASE_URL}/#/staff_member/1`;

// Jane discipline ids: 1 Pelvic Health & Wellness, 2 Pregnancy/Birth/Postpartum,
// 3 Perimenopause & Menopause Support, 4 Lactation Consulting
export const janeDisciplineLink = (disciplineId) =>
  `${JANE_BASE_URL}/#/discipline/${disciplineId}`;

export const serviceCategories = [
  {
    id: 'pelvic-health-wellness',
    title: 'Pelvic Health & Wellness',
    tagline: 'Personalized pelvic health care for every stage of life',
    description:
      'Individualized care for menstruation, pregnancy, postpartum recovery, perimenopause and menopause, with education and guidance tailored to your needs.',
    bookUrl: janeDisciplineLink(1)
  },
  {
    id: 'pregnancy-birth-postpartum',
    title: 'Pregnancy, Birth & Postpartum',
    tagline: 'Individualized support through pregnancy and recovery',
    description:
      'One-on-one maternity support through pregnancy, birth preparation and the postpartum weeks, shaped around your goals and preferences.',
    bookUrl: janeDisciplineLink(2)
  },
  {
    id: 'childbirth-education-cpr',
    title: 'Childbirth Education & CPR',
    tagline: 'Hands-on classes for confident, prepared parents',
    description:
      'Childbirth education covering labor, delivery, comfort techniques and postpartum preparation, plus hands-on infant CPR and safety training.',
    bookUrl: janeDisciplineLink(2)
  },
  {
    id: 'lactation-consulting',
    title: 'Lactation Consulting',
    tagline: 'Breastfeeding education and feeding guidance',
    description:
      'Breastfeeding preparation before baby arrives and personalized lactation support afterward, including latch, milk supply and feeding plans.',
    bookUrl: janeDisciplineLink(4)
  },
  {
    id: 'perimenopause-menopause',
    title: 'Perimenopause & Menopause',
    tagline: 'Education and support through midlife changes',
    description:
      'Compassionate care for the physical, hormonal and emotional changes of midlife, with education, lifestyle guidance and an individualized care plan.',
    bookUrl: janeDisciplineLink(3)
  },
  {
    id: 'maternity-concierge',
    title: 'Maternity Concierge',
    tagline: 'Ongoing, individualized attention throughout your journey',
    description:
      'A personalized concierge approach to pregnancy, childbirth preparation and postpartum support, beginning with a complimentary consultation.',
    bookUrl: janeDisciplineLink(2)
  }
];
